import Tag from "../GameInfo/Tag";
import QuinaIcon from "../Icon/QuinaIcon";
import MegaIcon from "../Icon/MegaIcon";
import LotoIcon from "../Icon/LotoIcon";

const GameTag: React.FC<{ tag: string; name?: string; light?: boolean }> = ({
  tag,
  name,
  light,
}) => {
  return (
    <>
      {tag === "quina" && (
        <Tag icon={<QuinaIcon size="14px" />} label={name} light={light} />
      )}
      {tag === "mega" && (
        <Tag icon={<MegaIcon size="14px" />} label={name} light={light} />
      )}
      {tag === "loto" && (
        <Tag icon={<LotoIcon size="14px" />} label={name} light={light} />
      )}
    </>
  );
};

export default GameTag;
